//export const URI = "http://api.vacations.local";
export const URI = "https://api.vacations.kefas.ovh/";
